import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { periodSchema } from "@go-novus/admin-api";

import { HomePage } from "#/pages/home";

// 只在路由这层对非法 period 回落，共享的 homeMetricsQuerySchema 不动：
// 服务端仍要对非法参数报 400，放宽的只是浏览器地址栏这一侧。
const homeSearchSchema = z.object({
  period: periodSchema.catch("last_7_days").default("last_7_days"),
});

export const Route = createFileRoute("/_console/")({
  component: HomeRoute,
  validateSearch: homeSearchSchema,
});

/** 周期是路由状态：刷新和前进后退都要能还原（PRD 4.1）。 */
function HomeRoute() {
  const { period } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <HomePage
      onPeriodChange={(next) => {
        void navigate({ search: { period: next } });
      }}
      period={period}
    />
  );
}
